import React, { useContext, useEffect, useState } from 'react';
import { useGlobalState } from '../../stateProvider/StateProvider';
import Input from '../Input';
import { Regex } from '../../utility/regex';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import { FormContext } from '../Form';

const EmailInput = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();
    const context = useContext(FormContext);
    const [state, setState] = useState(context.values[props.name || 'email']?.toLowerCase());

    useEffect(() => {
        if (context.values[props.name || 'email']) {
            setState(context.values[props.name || 'email'].toLowerCase())
        }
    }, [context.initial])


    return (
        <Input
            label='Email'
            name={[props.name || 'email']}
            type='email'
            validate={(e, setMsg, resolve) => {
                const inputEmail = e;
                if (e.match(Regex.match.email)) {
                    HamQuest.post(QuestRoute.validate.email, {
                        email: e
                    })
                        .then(res => {
                            if (inputEmail === active_user.account?.email || inputEmail.toLowerCase() === state) {
                                resolve(false);
                                return;
                            }
                            if (!res) setMsg('Email is already associated with an account.');
                            resolve(!res)
                        })
                        .catch((ex) => {
                            setMsg(ex.blob);
                        })
                } else {
                    setMsg('Please enter a valid email.');
                    resolve(true)
                }
            }}
            debounce={400}
            required
            {...props}
        />

    )
}

export default EmailInput;
